import React from 'react'
import Header from '../../components/Header'
import HeaderSecondary from '../../components/HeaderSecondary'
import ContainerPage from '../../components/Container'
import ContainerAccountLogin from '../../components/ContainerAccountLogin'
import HeaderMobile from '../../components/HeaderMobile'
import SidebarFilter from '../../components/SidebarFilterTest';

const PaymentLogin = () => {
    return (

        <ContainerPage>
            <Header />
            <HeaderMobile/>
            <HeaderSecondary />
            <SidebarFilter/>
            <ContainerAccountLogin route={"payment/login"}/>
        </ContainerPage>

    )
}

export default PaymentLogin